import api from './api';

export const sellCarService = {
  submitCarDetails: async (formData) => {
    try {
      const response = await api.post('/sell_requests', formData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getSellRequests: async () => {
    try {
      const response = await api.get('/sell_requests');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getSellRequest: async (id) => {
    try {
      const response = await api.get(`/sell_requests/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  updateSellRequest: async (id, data) => {
    try {
      const response = await api.put(`/sell_requests/${id}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  deleteSellRequest: async (id) => {
    try {
      const response = await api.delete(`/sell_requests/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};

export const inspectionService = {
  bookInspection: async (inspectionData) => {
    try {
      const response = await api.post('/car_inspections', inspectionData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getInspections: async () => {
    try {
      const response = await api.get('/car_inspections');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getInspection: async (id) => {
    try {
      const response = await api.get(`/car_inspections/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  updateInspection: async (id, data) => {
    try {
      const response = await api.patch(`/car_inspections/${id}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  cancelInspection: async (id) => {
    try {
      const response = await api.delete(`/car_inspections/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};